import { render, staticRenderFns } from "./Cenaculo.vue?vue&type=template&id=eca49ee0&scoped=true"
import script from "./Cenaculo.vue?vue&type=script&lang=js"
export * from "./Cenaculo.vue?vue&type=script&lang=js"
import style0 from "./Cenaculo.vue?vue&type=style&index=0&id=eca49ee0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca49ee0",
  null
  
)

export default component.exports